/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Raffle_Name_DefaultInputs */



/**
* | output |
* | --- |
* | "Raffle {n}" |
*
* @param {Raffle_Name_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_name_default = /** @type {((inputs: Raffle_Name_DefaultInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Name_DefaultInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tirage ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Sorteo ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Sorteio ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Estrazione ${i?.n}`)
	return /** @type {LocalizedString} */ (`Raffle ${i?.n}`)
});